import { DataInitialize } from './DataInitialize';
import {
  TaskRepository as FirebaseTaskRepository,
  TaskThreadRepository as FirebaseTaskThreadRepository,
  TaskThreadCommentRepository as FirebaseTaskThreadCommentRepository,
  TalkThreadCommentRepository as FirebaseTalkThreadCommentRepository,
  TalkThreadRepository as FirebaseTalkThreadRepository,
  NoteThreadRepository as FirebaseNoteThreadRepository,
  NoteThreadCommentRepository as FirebaseNoteThreadCommentRepository,
  AnnouncementThreadRepository as FirebaseAnnouncementThreadRepository,
  ConsultationRepository as FirebaseConsultationRepository,
  ConsultationCommentRepository as FirebaseConsultationCommentRepository
} from './Firebase/CollectionRepository';
import { DataCallback } from './DataCallback';
import { FirestoreRepository, DummyRepository } from './Firebase/FirestoreRepository';
import { Task, Talk, Note, Announcement, Consultation, Function} from '../Entities/Function';
import { Post, DummyPlainObject } from '../Entities/Chat/Post';

const threadPool: DummyPlainObject = {};

export abstract class ThreadRepository implements DataInitialize {
  protected firestore?: FirestoreRepository;

  public async getAll(callback: DataCallback): Promise<boolean>  {
    if (this.firestore) {
      return await this.firestore.getAll(callback);
    }

    return false;
  }

  public waitSnapshot(callback: DataCallback, lastUpdate: Date): void {
    if (this.firestore) 
      this.firestore.waitSnapshot(callback, lastUpdate);
  }

  get firestoreRepository(): FirestoreRepository {
    if (this.firestore) {
      return this.firestore;
    }

    return new DummyRepository();
  }

  public save(data:any) {
    this.firestoreRepository.save(data);
  }

  abstract hasChildRepository(): boolean;
  abstract childRepository(id: string): ThreadRepository;
}

export namespace ThreadRepository {
  export function getInstanceById(id: string): ThreadRepository | null{
    if (threadPool.hasOwnProperty(id)) {
      return threadPool[id];
    }

    return null
  }
  export function getInstance(func: Function<Post>, id: string, threadRepository: ThreadRepository): ThreadRepository {
    const firestoreRepository = threadRepository.firestoreRepository;
    if (func instanceof Task) {
      const thread = new TaskRepository(id, firestoreRepository);
      threadPool[id] = thread;
      return thread;
    }
    if (func instanceof Talk) {
      const thread = new TalkThreadRepository(id, firestoreRepository);
      threadPool[id] = thread;
      return thread;
    }
    if (func instanceof Note) {
      const thread = new NoteThreadRepository(id, firestoreRepository);
      threadPool[id] = thread;
      return thread;
    }
    if (func instanceof Announcement) {
      const thread = new AnnouncementThreadRepository(id, firestoreRepository);
      threadPool[id] = thread;
      return thread;
    }
    if (func instanceof Consultation) {
      return new ConsultationRepository(id, firestoreRepository);
    }

    
    
    return new AnnouncementThreadRepository(id, firestoreRepository);
  }
}

export class TaskRepository extends ThreadRepository {
  public hasChildRepository(): boolean {
    return true;
  }
  public childRepository(id: string): ThreadRepository {
    const thread = new TaskThreadRepository(id, this.firestore!);
    threadPool[id] = thread;
    return thread;
  }
  public constructor(private _id: string, firestoreRepository: FirestoreRepository) {
    super();
    this.firestore = new FirebaseTaskRepository(_id, firestoreRepository);
  }
}


export class TaskThreadRepository extends ThreadRepository {
  public hasChildRepository(): boolean {
    return true;
  }
  public childRepository(id: string): ThreadRepository {
    const thread = new TaskThreadCommentRepository(id, this.firestore!);
    threadPool[id] = thread;
    return thread;
  }
  public constructor(private _id: string, firestoreRepository: FirestoreRepository) {
    super();
    this.firestore = new FirebaseTaskThreadRepository(_id, firestoreRepository);
  }
}

export class TaskThreadCommentRepository extends ThreadRepository {
  public hasChildRepository(): boolean {
    return false;
  }
  public childRepository(id: string): ThreadRepository {
    throw new Error("Method not implemented.");
  }
  public constructor(private _id: string, firestoreRepository: FirestoreRepository) {
    super();
    this.firestore = new FirebaseTaskThreadCommentRepository(_id, firestoreRepository);
  }
}

export class TalkThreadRepository extends ThreadRepository {
  public hasChildRepository(): boolean {
    return true;
  }
  public childRepository(id: string): ThreadRepository {
    const thread = new TalkThreadCommentRepository(id, this.firestore!);
    threadPool[id] = thread;
    return thread;
  }
  public constructor(private _id: string, firestoreRepository: FirestoreRepository) {
    super();
    this.firestore = new FirebaseTalkThreadRepository(_id, firestoreRepository);
  }
}

export class TalkThreadCommentRepository extends ThreadRepository {
  public hasChildRepository(): boolean {
    return false;
  }
  public childRepository(id: string): ThreadRepository {
    throw new Error("Method not implemented.");
  }
  public constructor(private _id: string, firestoreRepository: FirestoreRepository) {
    super();
    this.firestore = new FirebaseTalkThreadCommentRepository(_id, firestoreRepository);
  }
}

export class ConsultationRepository extends ThreadRepository {
  public hasChildRepository(): boolean {
    return true;
  }
  public childRepository(id: string): ThreadRepository {
    const thread = new ConsultationCommentRepository(id, this.firestore!);
    threadPool[id] = thread;
    return thread;
  }
  public constructor(private _id: string, firestoreRepository: FirestoreRepository) {
    super();
    this.firestore = new FirebaseConsultationRepository(_id, firestoreRepository);
  }
}

export class ConsultationCommentRepository extends ThreadRepository {
  public hasChildRepository(): boolean {
    return false;
  }
  public childRepository(id: string): ThreadRepository {
    throw new Error("Method not implemented.");
  }
  public constructor(private _id: string, firestoreRepository: FirestoreRepository) {
    super();
    this.firestore = new FirebaseConsultationCommentRepository(_id, firestoreRepository);
  }
}

export class NoteThreadRepository extends ThreadRepository {
  public hasChildRepository(): boolean {
    return true;
  }
  public childRepository(id: string): ThreadRepository {
    const thread = new NoteThreadCommentRepository(id, this.firestore!);
    threadPool[id] = thread;
    return thread;
  }
  public constructor(private _id: string, firestoreRepository: FirestoreRepository) {
    super();
    this.firestore = new FirebaseNoteThreadRepository(_id, firestoreRepository);
  }
}

export class NoteThreadCommentRepository extends ThreadRepository {
  public hasChildRepository(): boolean {
    return false;
  }
  public childRepository(id: string): ThreadRepository {
    throw new Error("Method not implemented.");
  }
  public constructor(private _id: string, firestoreRepository: FirestoreRepository) {
    super();
    this.firestore = new FirebaseNoteThreadCommentRepository(_id, firestoreRepository);
  }
}

export class AnnouncementThreadRepository extends ThreadRepository {
  public hasChildRepository(): boolean {
    return false;
  }
  public childRepository(id: string): ThreadRepository {
    throw new Error("Method not implemented.");
  }
  public constructor(private _id: string, firestoreRepository: FirestoreRepository) {
    super();
    this.firestore = new FirebaseAnnouncementThreadRepository(_id, firestoreRepository);
  }
}